<template>
  <div class="modalAdd">
    <b-modal id="modalFolderDetail" ref="modalFolderDetail" centered modal-class="modal-no-border modal-radius modal-rename modal-folderDetail-e top-mb" size="lg">
      <template v-slot:modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <div class="title-modal text-center w-100 ">
          <div class="btn-closeModal" @click="close()">
            <svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
          </div>
        </div>
      </template>
      <div class="emp__folder--detail">
        <div class="block__left">
          <div class="block__left__icon">
            <div class="block__left--folder">
              <img src="@img/folder.svg" class="" />
              <span class="files__total">{{detailFolder.total_files}}</span>
            </div>
          </div>
        </div>
        <div class="block__right">
          <h2 class="title">フォルダ詳細</h2>
          <b-row class="infor-row">
            <b-col cols="4" class="pl-0">
              <div class="detail--title">フォルダ名</div>
            </b-col>
            <b-col cols="8">
              <div class="detail--content">{{truncate(detailFolder.name,15,'...')}}</div>
            </b-col>
          </b-row>
          <b-row class="infor-row">
            <b-col cols="4" class="pl-0">
              <div class="detail--title">作成者</div>
            </b-col>
            <b-col cols="8">
              <div class="detail--content">{{truncate(detailFolder.author,15,'...')}}</div>
            </b-col>
          </b-row>
          <b-row class="infor-row">
            <b-col cols="4" class="pl-0">
              <div class="detail--title">作成日</div>
            </b-col>
            <b-col cols="8">
              <div class="detail--content">{{dateFormat(detailFolder.updated_time)}}</div>
            </b-col>
          </b-row>
          <b-row class="infor-row">
            <b-col cols="4" class="pl-0">
              <div class="detail--title">サイズ</div>
            </b-col>
            <b-col cols="8">
              <div class="detail--content">{{convertSize(detailFolder.size)}}</div>
            </b-col>
          </b-row>
          <b-row class="infor-row">
            <b-col cols="4" class="pl-0">
              <div class="detail--title">ファイルパス</div>
            </b-col>
            <b-col cols="8">
              <div class="detail--content">{{'ファイル一覧 ' + ' ' + truncate(detailFolder.path,10,'...')}}</div>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'
import {mapState} from 'vuex'
export default {
  name: 'DetailFolder',
  data () {
    return {
      modalShow: false
    }
  },
  components: {
    'b-modal': BModal
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  computed: {
    ...mapState({
      detailFolder: state => state.employeeFolder.detailFolder
    })
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/stylesheet/auth/listfile.scss";
@import '@/assets/stylesheet/vendor/detail_vendor.scss';
@import "@/assets/stylesheet/mypage/detail_mypage.scss";
@import "@/assets/stylesheet/user/file_detail.scss";
</style>



// WEBPACK FOOTER //
// src/views/Employee/FolderManager/FolderDetail.vue